import React, { useState , useContext, useEffect } from "react";
import app from "../base";
import { withRouter } from "react-router-dom";
import { AuthContext } from "../Auth";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from "../images/logo text.png" 
import hos1 from "../images/hos1.jpg"
import hos2 from "../images/hos2.png"
import hos3 from "../images/hos3.png"
import hos4 from "../images/hos4.jpg"
import hos5 from "../images/hos5.jpg"
import hos6 from "../images/hos6.png"
import hos7 from "../images/hos7.png"
import hos8 from "../images/hos8.jpg"
import hos9 from "../images/hos9.jpg"
import hos10 from "../images/hos10.png"
import hos11 from "../images/hos11.jpg"
import hos12 from "../images/hos12.png"
import hos13 from "../images/hos13.jpg"
import hos14 from "../images/hos14.jpg"
import hos15 from "../images/hos15.jpg"
import hos16 from "../images/hos16.png"
import hos17 from "../images/hos17.png"
import hos18 from "../images/hos18.png"
import hos19 from "../images/hos19.png"
import hos20 from "../images/hos20.jpg"
import hos21 from "../images/hos21.jpg"
import hos22 from "../images/hos22.jpg"
import hos23 from "../images/hos23.png"
import hos24 from "../images/hos24.jpg"
import hos25 from "../images/hos25.jpg"
import hos26 from "../images/hos26.jpg"
import hos27 from "../images/hos27.png"
import hos28 from "../images/hos28.jpg"
import hos29 from "../images/hos29.jpg"
import hos30 from "../images/hos30.jpg"
import hos31 from "../images/hos31.png"
import hos32 from "../images/hos32.jpg"
import hos33 from "../images/hos33.jpg"
import hos34 from "../images/hos34.jpg"
import hos35 from "../images/hos35.jpg"
import hos36 from "../images/hos36.png"
import hos37 from "../images/hos37.jpeg"
import hos38 from "../images/hos38.jpg"



const SuggestionHospital2 = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  const [file, setFile] = useState(null);
  const [base64, setBase64] = useState(null);
  

  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };


   //usestate hook
   let [data, setData] = useState([]);
   const [select, setselect] = useState('');
   //custom data
   var dataa = [
   { id: 1, 
     name: 'โรงพยาบาลศิริราช คณะแพทยศาสตร์ศิริราชพยาบาล มหาวิทยาลัยมหิดล ', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.si.mahidol.ac.th/sirirajhospital/' ,
     img: hos1,
     map: "https://www.google.com/maps/place/Faculty+of+Medicine+Siriraj+Hospital,+Mahidol+University/@13.7599315,100.4836511,17z/data=!3m1!4b1!4m5!3m4!1s0x30e299ad894a4a39:0x9946a622d6bb1682!8m2!3d13.7599315!4d100.4858398"
   }, 
   { id: 2, 
     name: 'โรงพยาบาลจุฬาลงกรณ์ สภากาชาดไทย', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://chulalongkornhospital.go.th/kcmh/',
     img: hos2,
     map: "https://www.google.com/maps/place/King+Chulalongkorn+Memorial+Hospital/@13.7306726,100.5341872,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29f298a27c7e1:0xdb584fa3e3e2f5c0!8m2!3d13.7306674!4d100.5363812"
   }, 
   { id: 3, 
     name: 'โรงพยาบาลวชิรพยาบาล', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.vajira.ac.th/content/60cefcc2b11d0a7035126866',
     img: hos3,
     map: "https://www.google.com/maps/place/Vajira+Hospital/@13.7771621,100.5085848,16.34z/data=!4m5!3m4!1s0x30e2995ff3547271:0x29fa4e9a551a8175!8m2!3d13.7805712!4d100.5091916"
   }, 
   { id: 1, 
     name: 'สถาบันโรคทรวงอก', 
     city: 'นนทบุรี', 
     location: 'https://www.ccit.go.th/',
     img: hos4,
     map: "https://www.google.com/maps/place/Central+Chest+Institute+of+Thailand/@13.8619018,100.5193532,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29b5084ece23f:0xe837bdfa3dc9267f!8m2!3d13.8618966!4d100.5215472"
   }, 
   { id: 4, 
     name: 'คณะแพทยศาสตร์โรงพยาบาลรามาธิบดี มหาวิทยาลัยมหิดลโรงพยาบาลรามาธิบดี', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.rama.mahidol.ac.th/rama_hospital/',
     img: hos5,
     map: "https://www.google.com/maps/place/Faculty+of+Medicine+Ramathibodi+Hospital,+Mahidol+University/@13.7665157,100.5245281,17z/data=!3m1!4b1!4m5!3m4!1s0x30e2994da99aa1fd:0xc4dd9b398f456bcf!8m2!3d13.7665105!4d100.5267221"
   }, 
   { id: 5, 
     name: 'โรงพยาบาลภูมิพลอดุลยเดช กรมแพทย์ทหารอากาศ', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://bhumibolhospital.rtaf.mi.th/',
     img: hos6,
     map: "https://www.google.com/maps/place/Bhumibol+Adulyadej+Hospital/@13.9092566,100.6157025,17z/data=!3m1!4b1!4m5!3m4!1s0x30e28281e96f1241:0xf0100b33d0c4310!8m2!3d13.9092514!4d100.6178965"
   },
   { id: 1, 
     name: 'โรงพยาบาลมหาราชนครราชสีมา', 
     city: 'นครราชสีมา', 
     location: 'https://www.mnrh.go.th/th/',
     img: hos7,
     map: "https://www.google.com/maps/place/Maharat+Nakhon+Ratchasima+Hospital/@14.9848631,102.1012445,17z/data=!3m1!4b1!4m5!3m4!1s0x31194c9cf7fe4987:0x147aa6050cb4d3ba!8m2!3d14.9848579!4d102.1034385"
   },
   { id: 1, 
     name: 'โรงพยาบาลสงขลานครินทร์', 
     city: 'สงขลา', 
     location: 'https://hospital.psu.ac.th/',
     img: hos8,
     map: "https://www.google.com/maps/place/Songklanagarind+Hospital/@7.0069203,100.4922686,17z/data=!3m1!4b1!4m5!3m4!1s0x304d29afc4593253:0x9f440b35995a3d27!8m2!3d7.006915!4d100.4944626",
   },
   { id: 1, 
     name: 'โรงพยาบาลสรรพสิทธิประสงค์', 
     city: 'อุบลราชธานี', 
     location: 'https://www.sunpasit.go.th/',
     img: hos9,
     map: "https://www.google.com/maps/place/Sunpasitthiprasong+Hospital/@15.2360951,104.8632589,17z/data=!3m1!4b1!4m5!3m4!1s0x311687cbac1167bb:0x875f825eb9e2261c!8m2!3d15.2360899!4d104.8654529"
   },
   { id: 1, 
     name: 'โรงพยาบาลพระปกเกล้า', 
     city: 'จันทบุรี', 
     location: '',
     img: hos10,
     map: "https://www.google.com/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%9B%E0%B8%81%E0%B9%80%E0%B8%81%E0%B8%A5%E0%B9%89%E0%B8%B2/@12.6051481,102.1004312,17z/data=!3m1!4b1"
   },
   { id: 1, 
     name: 'โรงพยาบาลสุราษฏร์ธานี', 
     city: 'สุราษฏร์ธานี', 
     location: 'https://srth.go.th/',
     img: hos11,
     map: "https://www.google.com/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%AA%E0%B8%B8%E0%B8%A3%E0%B8%B2%E0%B8%A9%E0%B8%8F%E0%B8%A3%E0%B9%8C%E0%B8%98%E0%B8%B2%E0%B8%99%E0%B8%B5/@9.1315106,99.302527,15z/data=!3m1!4b1"
   },
   { id: 1, 
     name: 'โรงพยาบาลขอนแก่น', 
     city: 'ขอนแก่น', 
     location: 'https://www.kkh.go.th/',
     img: hos12,
     map: "https://www.google.com/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%82%E0%B8%AD%E0%B8%99%E0%B9%81%E0%B8%81%E0%B9%88%E0%B8%99/@16.431064,102.8308389,16z/data=!3m1!4b1"
   },
   { id: 1, 
     name: 'โรงพยาบาลพุทธชินราช', 
     city: 'พิษณุโลก', 
     location: 'https://budhosp.go.th/',
     img: hos13,
     map: "https://www.google.com/maps/place/Buddhachinaraj+Hospital/@16.8084305,100.2613445,17z/data=!3m1!4b1!4m5!3m4!1s0x30df97d7b2cf671b:0x47414a4e1e0e064b!8m2!3d16.8084254!4d100.2635385"
   },
   { id: 6, 
     name: 'โรงพยาบาลพระมงกุฎเกล้า', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.pmk.ac.th/index.php',
     img: hos14,
     map: "https://www.google.com/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%A1%E0%B8%87%E0%B8%81%E0%B8%B8%E0%B8%8E%E0%B9%80%E0%B8%81%E0%B8%A5%E0%B9%89%E0%B8%B2/@13.7676067,100.5320582,17z/data=!3m1!4b1"
   },
   { id: 7, 
     name: 'โรงพยาบาลตำรวจ', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.policehospital.org/content/home.php',
     img: hos15,
     map: "https://www.google.com/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%95%E0%B8%B3%E0%B8%A3%E0%B8%A7%E0%B8%88/@13.7437355,100.5372756,18.13z"
   },
   { id: 1, 
     name: 'โรงพยาบาลมหาราชนครเชียงใหม่ - คณะแพทยศาสตร์ มหาวิทยาลัยเชียงใหม่', 
     city: 'เชียงใหม่', 
     location: 'https://www.med.cmu.ac.th/web/suandok-hospital/',
     img: hos16,
     map: "https://www.google.com/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A3%E0%B8%B2%E0%B8%8A%E0%B8%99%E0%B8%84%E0%B8%A3%E0%B9%80%E0%B8%8A%E0%B8%B5%E0%B8%A2%E0%B8%87%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88+-+%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B9%81%E0%B8%9E%E0%B8%97%E0%B8%A2%E0%B8%A8%E0%B8%B2%E0%B8%AA%E0%B8%95%E0%B8%A3%E0%B9%8C+%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%A7%E0%B8%B4%E0%B8%97%E0%B8%A2%E0%B8%B2%E0%B8%A5%E0%B8%B1%E0%B8%A2%E0%B9%80%E0%B8%8A%E0%B8%B5%E0%B8%A2%E0%B8%87%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88/@18.78979,98.9742559,19.23z"
   },
   { id: 8, 
     name: 'โรงพยาบาลบำรุงราษฎร์', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.bumrungrad.com/th/fasttrack-pay?utm_source=sem-thai&utm_medium=sem&utm_campaign=smart-fasttrack-pay-1-nov-22&gclid=Cj0KCQiAx6ugBhCcARIsAGNmMbjnOh7J2qTakzAVw9tr8vIfm1DHPNIRmYBZlZJZZpC-2_gbKPxT4hIaAsxjEALw_wcB',
     img: hos17,
     map: "https://www.google.com/maps/place/Bumrungrad+International+Hospital/@13.746674,100.5518033,18.2z/data=!4m5!3m4!1s0x30e29ee677aa7f5b:0xf8a8de865c2e8a77!8m2!3d13.746066!4d100.5526867"
   },
   { id: 9, 
     name: 'โรงพยาบาลหัวใจกรุงเทพ', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.bangkokhearthospital.com/',
     img: hos18,
     map: "https://www.google.com/maps/place/Bangkok+Heart+Hospital/@13.7484366,100.583536,18.36z/data=!4m5!3m4!1s0x30e29f03af6bd52f:0xaf995a3d8adaf875!8m2!3d13.7480592!4d100.5833685"
   },
   { id: 10, 
     name: 'โรงพยาบาลเซนต์หลุยส์', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.saintlouis.or.th/th/index',
     img: hos19,
     map: "https://www.google.com/maps/place/Saint+Louis+Hospital/@13.7191176,100.5230104,17z/data=!3m1!4b1!4m5!3m4!1s0x30e298ca61ef5eb9:0x596d29764bda167c!8m2!3d13.7191124!4d100.5252044"
   },
   { id: 11, 
     name: 'โรงพยาบาลบางปะกอก 9 อินเตอร์​เนชั่นแนล​', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://bpk9internationalhospital.com/',
     img: hos20,
     map: "https://www.google.com/maps/place/Bangpakok+9+International+Hospital/@13.6821582,100.4744477,18.91z/data=!4m5!3m4!1s0x30e2a3db3418d1fb:0x75488923f0dc9f06!8m2!3d13.6818817!4d100.4745221"
   },
   { id: 12, 
     name: 'โรงพยาบาลรามคําแหง', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.ram-hosp.co.th/',
     img: hos21,
     map: "https://www.google.com/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%A3%E0%B8%B2%E0%B8%A1%E0%B8%84%E0%B9%8D%E0%B8%B2%E0%B9%81%E0%B8%AB%E0%B8%87/@13.7636615,100.6424582,15.92z"
   },
   { id: 6, 
    name: 'โรงพยาบาลกรุงเทพภูเก็ต', 
    city: 'ภูเก็ต', 
    location: 'https://www.phukethospital.com/th/',
    img: hos22,
    map: "https://www.google.co.th/maps/place/Bangkok+Hospital+Phuket/@7.9039809,98.3740986,17z/data=!3m1!4b1!4m5!3m4!1s0x3050319642447ddd:0x1912f364775aed3a!8m2!3d7.9039756!4d98.3762926"
  },
  { id: 6, 
    name: 'โรงพยาบาลกรุงเทพพัทยา', 
    city: 'พัทยา', 
    location: 'https://www.bangkokpattayahospital.com/th/',
    img: hos23,
    map: "https://www.google.co.th/maps/place/Bangkok+Hospital+Pattaya/@12.9538298,100.9033555,17z/data=!3m1!4b1!4m5!3m4!1s0x3102be152b37142d:0x81a466188fa77aa6!8m2!3d12.9538246!4d100.9055495"
  },
  { id: 13, 
    name: 'โรงพยาบาลพระราม 9', 
    city: 'กรุงเทพมหานคร', 
    location: 'https://www.praram9.com/?utm_term=%E0%B9%82%E0%B8%A3%E0%B8%87%20%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%20%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%A3%E0%B8%B2%E0%B8%A1%209&utm_campaign=sem-awo-traffic-brand&utm_source=adwords&utm_medium=ppc&hsa_acc=3237537901&hsa_cam=19673555908&hsa_grp=145556731426&hsa_ad=647925528380&hsa_src=g&hsa_tgt=kwd-868150103438&hsa_kw=%E0%B9%82%E0%B8%A3%E0%B8%87%20%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%20%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%A3%E0%B8%B2%E0%B8%A1%209&hsa_mt=e&hsa_net=adwords&hsa_ver=3&gclid=Cj0KCQjwk7ugBhDIARIsAGuvgPYs7WO56-_TNwbnFNuq2p40L9CLUaMSdSYG9Hkju1R_SSSF-J-6X8AaAomuEALw_wcB',
    img: hos24,
    map: "https://www.google.co.th/maps/place/Praram+9+Hospital/@13.7530601,100.5688253,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29ef4f449e749:0xb05ccd35cc25e092!8m2!3d13.7530549!4d100.5710193"
  },
  { id: 14, 
    name: 'โรงพยาบาลปิยะเวท', 
    city: 'กรุงเทพมหานคร', 
    location: 'https://piyavate.com/',
    img: hos25,
    map: "https://www.google.co.th/maps/place/Piyavate+Hospital/@13.7533874,100.5778907,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29e5e7726e455:0x4b1ab49dca7cb646!8m2!3d13.7533822!4d100.5800847"
  },
  { id: 15, 
    name: 'โรงพยาบาลวิชัยยุทธ', 
    city: 'กรุงเทพมหานคร', 
    location: '',
    img: hos26,
    map: "https://www.google.co.th/maps/place/Vichaiyut+Hospital/@13.7806262,100.5307382,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29c01bf84a57d:0x6f678539a140ccd9!8m2!3d13.780621!4d100.5329322"
  },
  { id: 16, 
    name: 'โรงพยาบาลเจ้าพระยา', 
    city: 'กรุงเทพมหานคร', 
    location: 'https://www.chaophya.com/',
    img: hos27,
    map: "https://www.google.co.th/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B9%80%E0%B8%88%E0%B9%89%E0%B8%B2%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%A2%E0%B8%B2/@13.7799495,100.4698488,18.19z"
  },
  { id: 17, 
    name: 'โรงพยาบาลพญาไท 2', 
    city: 'กรุงเทพมหานคร', 
    location: 'https://www.phyathai.com/branch/PYT2',
    img: hos28,
    map: "https://www.google.co.th/maps/place/Phyathai+2+Hospital/@13.7703996,100.5387634,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29eaff36c43ff:0xfa7be2811d3a6387!8m2!3d13.7703944!4d100.5409574"
  },
  { id: 18, 
    name: 'โรงพยาบาลสมิติเวช', 
    city: 'กรุงเทพมหานคร', 
    location: 'https://www.samitivejhospitals.com/th',
    img: hos29,
    map: "https://www.google.co.th/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%AA%E0%B8%A1%E0%B8%B4%E0%B8%95%E0%B8%B4%E0%B9%80%E0%B8%A7%E0%B8%8A/@13.7350832,100.5694515,15.84z"
  },
  { id: 19, 
    name: 'โรงพยาบาลธนบุรี 1', 
    city: 'กรุงเทพมหานคร', 
    location: 'https://www.thonburihospital.com/',
    img: hos30,
    map: "https://www.google.co.th/maps/place/Thonburi+Hospital/@13.7527312,100.4776802,17z/data=!3m1!4b1!4m5!3m4!1s0x30e299a410db3aeb:0x68733fd8e885ed0c!8m2!3d13.752726!4d100.4798742"
  },
  { id: 20, 
    name: 'โรงพยาบาลพญาไท 3', 
    city: 'กรุงเทพมหานคร', 
    location: 'https://phyathai3hospital.com/home/',
    img: hos31,
    map: "https://www.google.co.th/maps/place/Phyathai+3+Hospital/@13.7229782,100.4618814,17z/data=!3m1!4b1!4m5!3m4!1s0x30e2984634badc79:0xd5f0e330080118f4!8m2!3d13.722973!4d100.4640754"
  },
  { id: 21, 
    name: 'โรงพยาบาลวิภาวดี', 
    city: 'กรุงเทพมหานคร', 
    location: 'https://www.vibhavadi.com/',
    img: hos32,
    map: "https://www.google.co.th/maps/place/Vibhavadi+Hospital/@13.8462595,100.5599299,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29ce7c2c0e5cd:0xf936935a200bf7af!8m2!3d13.8462543!4d100.5621239"
  },
  { id: 22, 
    name: 'โรงพยาบาลเกษมราษฎร์ ประชาชื่น', 
    city: 'กรุงเทพมหานคร', 
    location: 'https://www.kasemrad.co.th/Prachachuen/th/site/packages_and_promotions',
    img: hos33,
    map: "https://www.google.co.th/maps/place/Kasemrad+Prachachuen+Hospital/@13.831699,100.5368034,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29dc7e1bb556b:0x10a210f32d43c8a3!8m2!3d13.8316938!4d100.5389974"
  },
  { id: 1, 
    name: 'โรงพยาบาลชลบุรี', 
    city: 'ชลบุรี', 
    location: 'http://www.cbh.moph.go.th/cbh2020/',
    img: hos34,
    map: "https://www.google.co.th/maps/place/Chonburi+Hospital/@13.3519914,100.9799793,17z/data=!3m1!4b1!4m5!3m4!1s0x311d35804629950f:0xf03d84bc0dd45c0!8m2!3d13.3519862!4d100.9821733"
  },
   { id: 23, 
     name: 'โรงพยาบาลราชวิถี', 
     city: 'กรุงเทพมหานคร', 
     location: 'https://www.rajavithi.go.th/',
     img: hos35,
     map: "https://www.google.com/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B8%A3%E0%B8%B2%E0%B8%8A%E0%B8%A7%E0%B8%B4%E0%B8%96%E0%B8%B5/@13.7637534,100.611966,13z/data=!3m1!4b1"
   },
   { id: 2, 
     name: 'โรงพยาบาลมหาวิทยาลัยนเรศวร คณะแพทยศาสตร์ มหาวิทยาลัยนเรศวร', 
     city: 'พิษณุโลก', 
     location: 'https://med.nu.ac.th/nuh/',
     img: hos36,
     map: "https://www.google.com/maps/place/Faculty+of+Medicine,+Naresuan+University/@16.7484843,100.1887835,18.57z/data=!4m5!3m4!1s0x30dfbea165abb7bb:0x5327484d2579c35a!8m2!3d16.7485439!4d100.1890896"
   },
   { id: 1, 
     name: 'โรงพยาบาลธรรมศาสตร์เฉลิมพระเกียรติ', 
     city: 'ปทุมธานี', 
     location: 'https://www.hospital.tu.ac.th/',
     img: hos37,
     map: "https://www.google.com/maps/place/Thammasat+University+Hospital/@14.0736214,100.6139571,17.82z/data=!4m5!3m4!1s0x30e27f8b5240581d:0xecfc2bf4fa4f2a60!8m2!3d14.0736411!4d100.6152918"
   },
   { id: 2, 
     name: 'โรงพยาบาลเชียงใหม่ ราม', 
     city: 'เชียงใหม่', 
     location: 'https://www.chiangmairam.com/',
     img: hos38,
     map: "https://www.google.com/maps/place/Chiang+Mai+Ram+Hospital/@18.7950227,98.9780048,18.59z/data=!4m5!3m4!1s0x30da2fe5554fd6d1:0xd8b86ad5b4e32e30!8m2!3d18.7947974!4d98.9779833"
   }
 ];
   //Select onchage function, getting option selected value and save inside state variable
   function handleChange (e){
     //set state variable with option value
     setselect(e.target.value);
    
   };
   
  
   
   useEffect(() => {
     //Doing filteration on according to select state option
     data = dataa.filter(dataa => dataa.city == select);
     //set state variable data after filteration
     setData(data);
     }, [select])
 
 

// Change file to Field for firestore

  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/en/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/">
              Service <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center>
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/">
              News from EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/about">
              About us
            </Nav.Link>
          </li>
        </center>
        
        
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >Sign out</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/en/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/SuggestionHospital2">
              TH |
            </Nav.Link>
          </li>
        </center>

        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/SuggestionHospital2">
              EN
            </Nav.Link>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>


  <center>
     {/* Header */}
  <header className="ex-header bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-xl-10 offset-xl-1">
        <h1 >Find Thailand's Heart Center Hospital Near you</h1>
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </header>{" "}
  </center>
  {/* end of ex-header */}
  {/* end of header */}
  {/* Basic */}
    <center>
    <button  style={{marginTop: "4%"}} className="btn-solid-lgr" onClick={(e) => {
      e.preventDefault();
      window.location.href='https://www.google.co.th/maps/search/%E0%B9%82%E0%B8%A3%E0%B8%87%E0%B8%9E%E0%B8%A2%E0%B8%B2%E0%B8%9A%E0%B8%B2%E0%B8%A5%E0%B9%83%E0%B8%81%E0%B8%A5%E0%B9%89%E0%B8%89%E0%B8%B1%E0%B8%99/';
      }}>
      Find nearest Hospital

      </button>
      <br/>
      <br/>
      <img style={{borderRadius: "10px" , width: "20%"}}src= "https://www.imarketingonly.com/wp-content/uploads/2018/07/feature-googlemap.jpg"/>

    </center>


    <br/>
  <br/>
  <br/>
  <br/>
  <div className="app container p-5">
      <h1 className="text-center mb-2">Hospital list considered "Hearth Center" 38 places in Thailand</h1>
      <p className="text-center mb-5 fs-5 " style={{}} >From : The Heart Association of Thailand under the Royal Patronage.</p>
      <a  className="btn-solid-lg page-scroll mx-3 my-4" href="/Telemedicine">Find Hearth Doctors/Physician</a>
      <div class="mb-3">
         <p className=" fs-4 " style={{color: "red"}} class="form-label">Select your Province</p>
           <select id="state" style={{borderRadius: "10px" , width: "20%"}}
             onChange={handleChange} class="form-select mb-5">
                <option value="กรุงเทพมหานคร">กรุงเทพมหานคร</option>
                <option value="สุราษฏร์ธานี">กระบี่</option>
                <option value="พิษณุโลก">กาญจนบุรี</option>
                <option value="ขอนแก่น">กาฬสินธุ์</option>
                <option value="พิษณุโลก">กำแพงเพชร</option>
                <option value="ขอนแก่น">ขอนแก่น</option>
                <option value="จันทบุรี">จันทบุรี</option>
                <option value="ปทุมธานี">	ฉะเชิงเทรา</option>
                <option value="ชลบุรี">	ชลบุรี</option>
                <option value="กรุงเทพมหานคร">	ชัยนาท</option>
                <option value="ขอนแก่น">	ชัยภูมิ</option>
                <option value="สุราษฏร์ธานี">	ชุมพร</option>
                <option value="เชียงใหม่">	เชียงราย</option>
                <option value="เชียงใหม่">เชียงใหม่</option>
                <option value="สงขลา">	ตรัง</option>
                <option value="จันทบุรี">	ตราด</option>
                <option value="เชียงใหม่">	ตาก</option>
                <option value="ปทุมธานี">	นครนายก</option>
                <option value="นนทบุรี">นนทบุรี</option>
                <option value="นนทบุรี">	นครปฐม</option>
                <option value="ขอนแก่น">	นครพนม</option>
                <option value="ปทุมธานี">	นครราชสีมา</option>
                <option value="สุราษฏร์ธานี">	นครศรีธรรมราช</option>
                <option value="พิษณุโลก">	นครสวรรค์</option>
                <option value="สงขลา">	นราธิวาส</option>
                <option value="เชียงใหม่">	น่าน</option>
                <option value="ขอนแก่น">	บึงกาฬ</option>
                <option value="อุบลราชธานี">	บุรีรัมย์</option>
                <option value="กรุงเทพมหานคร">	ประจวบคีรีขันธ์	</option>
                <option value="กรุงเทพมหานคร">	ปราจีนบุรี</option>
                <option value="สงขลา">	ปัตตานี</option>
                <option value="ปทุมธานี">ปทุมธานี</option>
                <option value="นนทบุรี"> พระนครศรีอยุธยา</option>
                <option value="พิษณุโลก">พิษณุโลก</option>
                <option value="เชียงใหม่">	พะเยา</option>
                <option value="สุราษฏร์ธานี">	พังงา</option>
                <option value="สงขลา">	พัทลุง</option>
                <option value="พิษณุโลก">	พิจิตร</option>
                <option value="กรุงเทพมหานคร">	เพชรบุรี</option>
                <option value="พิษณุโลก">	เพชรบูรณ์</option>
                <option value="เชียงใหม่">	แพร่</option>
                <option value="สุราษฏร์ธานี">	ภูเก็ต</option>
                <option value="ขอนแก่น">	มหาสารคาม</option>
                <option value="อุบลราชธานี">	มุกดาหาร</option>
                <option value="เชียงใหม่">	แม่ฮ่องสอน</option>
                <option value="อุบลราชธานี">	ยโสธร</option>
                <option value="สงขลา">	ยะลา</option>
                <option value="อุบลราชธานี">	ร้อยเอ็ด</option>
                <option value="สุราษฏร์ธานี">	ระนอง</option>
                <option value="จันทบุรี">	ระยอง</option>
                <option value="กรุงเทพมหานคร">	ราชบุรี</option>
                <option value="กรุงเทพมหานคร">	ลพบุรี</option>
                <option value="เชียงใหม่">	ลำปาง</option>
                <option value="เชียงใหม่">	ลำพูน</option>
                <option value="พิษณุโลก">	เลย</option>
                <option value="อุบลราชธานี">	ศรีสะเกษ</option>
                <option value="ขอนแก่น">	สกลนคร</option>
                <option value="สงขลา">สงขลา</option>
                <option value="สุราษฏร์ธานี">สุราษฏร์ธานี</option>
                <option value="สงขลา">	สตูล</option>
                <option value="กรุงเทพมหานคร">	สมุทรปราการ</option>
                <option value="กรุงเทพมหานคร">	สมุทรสงคราม</option>
                <option value="กุงเทพมหานคร">	สมุทรสาคร</option>
                <option value="จันทบุรี">	สระแก้ว</option>
                <option value="ปทุมธานี">	สระบุรี</option>
                <option value="นนทบุรี">สิงห์บุรี</option>
                <option value="พิษณุโลก">	สุโขทัย</option>
                <option value="กรุงเทพมหานคร">	สุพรรณบุรี</option>
                <option value="อุบลราชธานี">	สุรินทร์</option>
                <option value="ขอนแก่น">	หนองคาย</option>
                <option value="ขอนแก่น">	หนองบัวลำภู</option>
                <option value="ปทุมธานี">	อ่างทอง</option>
                <option value="อุบลราชธานี">	อำนาจเจริญ</option>
                <option value="ขอนแก่น">	อุดรธานี</option>
                <option value="พิษณุโลก">	อุตรดิตถ์</option>
                <option value="พิษณุโลก">	อุทัยธานี</option>
                <option value="อุบลราชธานี">อุบลราชธานี</option>

            </select>
      </div>
      <table class="table table-hover table-bordered p-5 text-center table-responsive" style={{borderRadius: "10px"}}>
        
        <thead>
        
          <tr>
            <th scope="col">No.</th>
            <th scope="col">Name</th>
            <th scope="col">Province</th>
            <th scope="col">Contact</th>
            <th scope="col"></th>
          </tr>
        
        </thead>
        <tbody>
        { // calling state variable data to filter data inside table
        data.map(function({id, name, city, location, img, map}){
         
              return (
                
                <tr>
               
                <td>{id}</td>
                <td>{name}</td>
                <td>{city}</td>
                <td>
                  <center>
                <button className="btn-solid-lg my-4" onClick={(e) => {
                  e.preventDefault();
                  window.location.href= location;
                }}>Website</button>

                <button className="btn-solid-lgs my-4 mx-4" onClick={(e) => {
                  e.preventDefault();
                  window.location.href= map;
                }}>Map</button>
                </center>
                </td>
                <center>
                <img style={{width: "100px"}} src = {img}/>
                </center>
              </tr>
                );
            })}
            
            </tbody>
            </table>
        
       </div>
  

      
    </>
  );
};

export default withRouter(SuggestionHospital2);